module.exports = __webpack_public_path__ + "static/media/award.94139bfb.svg";